// extracted by mini-css-extract-plugin
export var banner = "styles-module--banner--ECAEZ";
export var banner_opened = "styles-module--banner_opened--h53rg";
export var banner__wrapper = "styles-module--banner__wrapper--o6jRa";
export var banner__wrapper_opened = "styles-module--banner__wrapper_opened--GJZ7-";
export var banner__wrapper_hidden = "styles-module--banner__wrapper_hidden--Rl4z5";
export var banner__content = "styles-module--banner__content---a7bf";
export var banner__button = "styles-module--banner__button--TY7YX";